import { Fragment } from 'react';

import { FuelConsumption } from './FuelConsumption';
import type { FuelType } from './FuelConsumption';
import { FUEL_TYPES } from 'config/app-config';
export const testId = 'energeyEstimationTestId';

type Consumption = {
  [FUEL_TYPES.ELECTRIC]: number;
  [FUEL_TYPES.GAS]: number;
};

type EnergyEstimationProps = {
  fuelType: FuelType;
  consumption: Consumption;
};

export const EnergyEstimation = ({
  fuelType,
  consumption
}: EnergyEstimationProps) => {
  return (
    <>
      <p>Based on your answers, we expect your usage could be:</p>
      <p>
        {Object.entries(fuelType).map(
          ([fuel, value]) =>
            value && (
              <Fragment key={fuel}>
                <FuelConsumption
                  fuel={fuel as typeof FUEL_TYPES[keyof typeof FUEL_TYPES]}
                  consumption={consumption[fuel as keyof typeof FUEL_TYPES]}
                />
                <br />
              </Fragment>
            )
        )}
      </p>
    </>
  );
};
